export default "__VITE_ASSET__DKLFc4JP__"